import HubspotFormModal from "modal/HubspotFormModal";
import {handleHubspotForm} from "util/hubspot";

export default class ProfileModal extends HubspotFormModal {

    buildModal() {
        let position = this.$elem.find('.js-position').text();
        let name = this.$elem.find('.js-name').text();

        let $image = this.$elem.find('.js-image').clone();
        $image.show();

        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--profile"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close-btn close-btn close-btn--small close-btn--dark js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__person modal-person"}, [
                        eotwJSXFactory('div', {className: "modal-person__image"}, [
                            $image
                        ]),
                        eotwJSXFactory('div', {className: "modal-person__info"}, [
                            eotwJSXFactory('h3', {className: "heading heading--3 heading--no-full-stop"}, [name]),
                            eotwJSXFactory('h5', {className: "modal-person__title heading heading--5"}, [position])
                        ])
                    ]),
                    eotwJSXFactory('div', {className: "modal__content"}, [
                        eotwJSXFactory('div', {className: "modal__header"}, [
                            eotwJSXFactory('h2', {className: "heading heading--2"}, ["Contacta ", name]),
                            eotwJSXFactory('p', null, ["Completa el formulario y escribe un mensaje para contactar directamente con ", name])
                        ]),
                        eotwJSXFactory('div', {className: "modal__form form form--white"}, [
                            eotwJSXFactory('div', {className: "js-hubspot-container hubspot-container", 'data-hubspot-class': "modal", 'data-portal-id': "2188024", 'data-form-id': this.formId})
                        ])
                    ])
                ])
            ])
        );
    }
}